import angular from 'angular'
import deductionPage from './view/deductionPolicy.html'

class deductionPolicyCtrl {
    constructor(httpRequest, sweetalert) {
        const scope = this
        scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                zsxmmc: '',
                jmxzDmAndJmxmmc: '',
                accessToken: localStorage.getItem('id_token'),
            },
        }
        scope.reset = function () {
            scope.queryParam.param = {
                zsxmmc: '',
                jmxzDmAndJmxmmc: '',
                accessToken: localStorage.getItem('id_token'),
            }
        }
        // scope.reset()
        scope.queryList = function queryList() {
            httpRequest.post_getSbJmszcDmList(scope.queryParam).then((res) => {
                scope.listData = res.data.value.list
                scope.totalItems = res.data.value.total
                scope.queryParam.pageNum = res.data.value.pageNum
            })
        }
        scope.queryList()
        scope.importconfig = {
            code: 'JMSZC', // 'ZZSYSXM'
            validate: {
                pattern: '.xlsx,.xls',
                _validate: {
                    size: { min: 10, max: '10MB' },
                    duration: { min: '10s', max: '5m' },
                    accept: '.xlsx,.xls',
                },
            },
            appName: host.etcloudSb,
            hideDownload: true,
            callback() {
                scope.queryList()
            },
        }

        // 表头排序
        scope.orderMap = { sortKey: '', sortVal: '' }
        scope.selectedHandle = function selectedHandle() {
            scope.queryParam.orderMap = {}
            if (scope.orderMap.sortKey) scope.queryParam.orderMap[scope.orderMap.sortKey] = scope.orderMap.sortVal
            scope.queryList()
        }
        // 导入确认弹窗
        scope.upload = function upload() {
            const msg = '导入后将全面覆盖已有的减免税政策代码表，确定要导入吗？'
            sweetalert.confirm('确认上传', msg).then(() => {
                angular.element('#deduction-upload .j-importexcel').click()
            }, () => { })
        }
        // 导出
        scope.exportTaxClass = function exportTaxClass() {
            httpRequest.get_exportSbJmszcDmToExcel(scope.queryParam.param)
        }
    }
}
deductionPolicyCtrl.$inject = ['httpRequest', 'sweetalert']
export default angular.module('system.basedata.taxPolicy.deduction', [])
    .controller('deductionPolicyCtrl', deductionPolicyCtrl)
    .component('deductionPolicy', {
        template: deductionPage,
        controller: 'deductionPolicyCtrl',
    }).name



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxClass/deductionPolicyComponent.js